import { useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';

import { errorNormalizer } from '../../../shared/Helpers/functions';
import { clientReducer } from './clientReducer';
import { initialAddClientState } from './clientInitialStates';
import ClientForm from './clientForm';
import DuplicateWarningModal from './DuplicateWarningModal';

import { DispatchProperties } from '../../../redux/store';
import { addClient } from '../../../redux/State/clientSlice/clientSlice';
import { DuplicateMatchProperties } from '../../../redux/API/ClientAPIHelpers/clientProperties';

const AddClient = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();

	const [clientInfo, setClientInfo] = useReducer(clientReducer, initialAddClientState);
	const [duplicates, setDuplicates] = useState<DuplicateMatchProperties[]>([]);
	const [showDuplicateWarning, setShowDuplicateWarning] = useState<boolean>(false);
	const [serverErrors, setServerErrors] = useState<Record<string, string>>({});

	const getClientData = () => ({
		...clientInfo,
		firstName: clientInfo.firstName.trim(),
		lastName: clientInfo.lastName.trim(),
	});

	const addClientHandler = () => {
		dispatch(addClient(getClientData()))
			.then(unwrapResult)
			.then(() => navigate(-1))
			.catch((error) => {
				if (error?.duplicates) {
					setDuplicates(error.duplicates);
					setShowDuplicateWarning(true);

					return;
				}

				if (error?.errors) {
					setServerErrors(error.errors);
				}
				errorNormalizer(error);
			});
	};

	const onConfirmDuplicate = () => {
		setShowDuplicateWarning(false);
		dispatch(addClient({ ...getClientData(), acknowledgeDuplicates: true }))
			.then(unwrapResult)
			.then(() => navigate(-1))
			.catch(errorNormalizer);
	};

	const onCancelDuplicate = () => {
		setShowDuplicateWarning(false);
		setDuplicates([]);
	};

	return (
		<>
			<ClientForm
				clientInfo={clientInfo}
				setClientInfo={setClientInfo}
				saveClientHandler={addClientHandler}
				duplicateWarnings={duplicates}
				serverErrors={serverErrors}
			/>
			<DuplicateWarningModal
				open={showDuplicateWarning}
				duplicates={duplicates}
				onConfirm={onConfirmDuplicate}
				onCancel={onCancelDuplicate}
			/>
		</>
	);
};

export default AddClient;
